import { type FC, type PropsWithChildren } from 'react'
import styled from 'styled-components'

import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

type TakeoverContentWrapperBaseProps = PropsWithChildren<{
  hasTakeover: boolean
}>

const ContentWrapper = styled.div<{ $hasTakeover: boolean }>(
  ({ theme, $hasTakeover }) => `
  position: relative;
  transition: all 0.3s ease;

  ${
    $hasTakeover
      ? `
    ${MEDIA_QUERIES(theme).large} {
      z-index: 1;
      pointer-events: none;
    }
  `
      : ''
  }
`
)

export const TakeoverContentWrapperBase: FC<TakeoverContentWrapperBaseProps> = ({
  children,
  hasTakeover,
}) => {
  return <ContentWrapper $hasTakeover={hasTakeover}>{children}</ContentWrapper>
}
